import getRole from "./RoleService";

const uri = `${import.meta.env.VITE_BASE_URL}/api/acception-config`;

const AddPostCode = async (list_config) => {
  try {
    const role = await getRole();
    if (role) {
      const { token } = role;
      const formData = new FormData();
      formData.append("list_config", list_config);
      const response = await fetch(`${uri}`, {
        method: "POST",
        headers: {
          authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      const data = await response.json();
      if (response.status === 200) {
        return data;
      } else if (response.status === 401) {
        return {
          status_code: 401,
          message: "Token hết hạn, vui lòng đăng nhập lại.",
        };
      } else {
        return {
          status_code: 500,
          message: "Lỗi không xác định!",
        };
      }
    } else {
      return {
        status_code: 401,
        message: "Token hết hạn, vui lòng đăng nhập lại.",
      };
    }
  } catch (err) {
    console.log(err);
    return { success: false, message: "Lỗi server" };
  }
};

const UpdatePostCode = async (idConfig, list_config, active, isCurrentUsed) => {
  try {
    const role = await getRole();
    if (role) {
      const { token } = role;

      const formData = new FormData();
      formData.append("idConfig", idConfig);
      formData.append("list_config", list_config);
      formData.append("active", active);
      formData.append("isCurrentUsed", isCurrentUsed);

      const response = await fetch(`${uri}/update`, {
        method: "post",
        headers: {
          authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      const data = await response.json();
      if (response.status === 200) {
        return data;
      } else if (response.status === 401) {
        return {
          status_code: 401,
          message: "Token hết hạn, vui lòng đăng nhập lại.",
        };
      } else {
        return {
          status_code: 500,
          message: "Lỗi không xác định!",
        };
      }
    } else {
      return {
        status_code: 401,
        message: "Token hết hạn, vui lòng đăng nhập lại.",
      };
    }
  } catch (err) {
    console.log(err);
    return { success: false, message: "Lỗi server" };
  }
};
const GetListPostCodeById = async (id) => {
  try {
    const role = await getRole();
    if (role) {
      const { token } = role;

      const response = await fetch(`${uri}/${id}`, {
        method: "get",
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();
      if (response.status === 200) {
        return data;
      } else if (response.status === 401) {
        return {
          status_code: 401,
          message: "Token hết hạn, vui lòng đăng nhập lại.",
        };
      } else {
        return {
          status_code: 500,
          message: "Lỗi không xác định!",
        };
      }
    } else {
      return {
        status_code: 401,
        message: "Token hết hạn, vui lòng đăng nhập lại.",
      };
    }
  } catch (err) {
    console.log(err);
    return { success: false, message: "Lỗi server" };
  }
};
const GetAllListPostCode = async (
  id,
  isCurrentUsed,
  listConfig,
  createdAtFrom,
  createdAtTo
) => {
  try {
    const role = await getRole();
    if (role) {
      const { token } = role;
      const active = 1;
      const queryParams = new URLSearchParams({
        id,
        active,
        isCurrentUsed,
        listConfig,
        createdAtFrom,
        createdAtTo,
      }).toString();
      const response = await fetch(`${uri}/get-all?${queryParams}`, {
        method: "get",
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();
      if (response.status === 200) {
        return data;
      } else if (response.status === 401) {
        return {
          status_code: 401,
          message: "Token hết hạn, vui lòng đăng nhập lại.",
        };
      } else {
        return {
          status_code: 500,
          message: "Lỗi không xác định!",
        };
      }
    } else {
      return {
        status_code: 401,
        message: "Token hết hạn, vui lòng đăng nhập lại.",
      };
    }
  } catch (err) {
    console.log(err);
    return { success: false, message: "Lỗi server" };
  }
};
const ExcuteListPostCode = async (id, auto_reject) => {
  try {
    const role = await getRole();
    if (role) {
      const { token } = role;

      const formData = new FormData();
      formData.append("auto_reject", auto_reject);

      const response = await fetch(`${uri}/${id}/excute`, {
        method: "post",
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      const data = await response.json();
      if (response.status === 200) {
        return data;
      } else if (response.status === 401) {
        return {
          status_code: 401,
          message: "Token hết hạn, vui lòng đăng nhập lại.",
        };
      } else {
        return {
          status_code: 500,
          message: "Lỗi không xác định!",
        };
      }
    } else {
      return {
        status_code: 401,
        message: "Token hết hạn, vui lòng đăng nhập lại.",
      };
    }
  } catch (err) {
    console.log(err);
    return { success: false, message: "Lỗi server" };
  }
};
const ExcuteAllListPostCode = async (auto_reject) => {
  try {
    const role = await getRole();
    if (role) {
      const { token } = role;

      const formData = new FormData();
      formData.append("auto_reject", auto_reject);

      const response = await fetch(`${uri}/excute-all-current-used`, {
        method: "post",
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      const data = await response.json();
      if (response.status === 200) {
        return data;
      } else if (response.status === 401) {
        return {
          status_code: 401,
          message: "Token hết hạn, vui lòng đăng nhập lại.",
        };
      } else {
        return {
          status_code: 500,
          message: "Lỗi không xác định!",
        };
      }
    } else {
      return {
        status_code: 401,
        message: "Token hết hạn, vui lòng đăng nhập lại.",
      };
    }
  } catch (err) {
    console.log(err);
    return { success: false, message: "Lỗi server" };
  }
};

export {
  AddPostCode,
  UpdatePostCode,
  GetListPostCodeById,
  GetAllListPostCode,
  ExcuteAllListPostCode,
  ExcuteListPostCode,
};
